import { render, staticRenderFns } from "./StandaloneJournal.vue?vue&type=template&id=7bb60048&"
import script from "./StandaloneJournal.vue?vue&type=script&lang=js&"
export * from "./StandaloneJournal.vue?vue&type=script&lang=js&"
import style0 from "./StandaloneJournal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports